import {getMapControlsWidth} from '@map/controls/ControlsDrawer';
import {getSidebarWidth} from '@map/sidebars';
import type mapboxgl from 'mapbox-gl';

/**
 * Calculates whether a point is behind the sidebar for the given map viewport.
 */
export default function isPointBehindSidebar(
    map: mapboxgl.Map,
    coordinates: mapboxgl.LngLatLike,
    controlsExpanded = true
) {
    const {x} = map.project(coordinates);
    const padding = getSidebarWidth() + getMapControlsWidth(controlsExpanded);
    return x < padding;
}
